import { useFormContext } from "react-hook-form";
import { useCheckoutBasicDetailsContext } from "repoV2/features/CheckoutPages/modules/CheckoutBasicDetailsContextProvider";
import { IClassDetails } from "repoV2/features/CheckoutPages/utils/apis/SessionDetailsApi/SessionDetailsApi.interface";
import { pluralise } from "repoV2/features/Common/utils/strings";
import { IExlySearchableDropdownOption } from "repoV2/features/Common/modules/Form/modules/ExlySearchableDropdown/ExlySearchableDropdown.interfaces";
import useGetFormData from "repoV2/features/Common/modules/FormData/utils/useGetFormData";
import { IMultipleUsersHelpers } from "repoV2/features/Common/modules/FormData/interfaces/MultipleUserHelpers.interfaces";
import {
    FORM_KEYS,
    multiple_users_helpers_keys,
} from "repoV2/features/Common/modules/FormData/FormData.constants";
import useToastMessage from "repoV2/components/common/Toast/useToastMessage";
import { getSelectedSessionDetailsFieldName } from "../../../../SessionDetailsFormGroup.utils";
import { getClassesRenderData } from "../../utils/getClassesRenderData";

export const getClassesDropdownOptions = (classes: IClassDetails[]) => {
    const newClasses: IExlySearchableDropdownOption[] = [];
    classes.forEach((classItem, idx) => {
        const { renderSchedultType, renderStartingDate, slotsLabel } =
            getClassesRenderData({ classItem });

        const renderLabelValue = `<div>
                <strong>${renderSchedultType} Batch ${idx + 1} - </strong>
                <span>${slotsLabel}</span> | Starts on
                <strong> ${renderStartingDate}</strong>
            </div>`;
        const labelValue = `${renderSchedultType} Batch ${
            idx + 1
        } - ${slotsLabel} | Starts on ${renderStartingDate}`;

        newClasses.push({
            id: classItem.uuid,
            label: labelValue,
            value: classItem.uuid,
            selectedLabel: labelValue,
            data: {
                renderLabelValue,
            },
        });
    });

    return newClasses;
};

const useMultipleSessions = ({
    classes,
    maxSpots,
}: {
    classes: IClassDetails[];
    maxSpots: number;
}) => {
    const { setValue } = useFormContext();
    const { listingUuid, listingType } = useCheckoutBasicDetailsContext();
    const { notify, toast_type_keys } = useToastMessage();

    const multipleSessionsFieldName = getSelectedSessionDetailsFieldName({
        listingUuid,
        listingType,
    });

    const classesOptions = getClassesDropdownOptions(classes);

    const allUserIds = useGetFormData<IMultipleUsersHelpers["allUserIds"]>({
        key: `${FORM_KEYS.multiple_users_helpers}.${multiple_users_helpers_keys.all_user_ids}`,
    });

    const batchesSelectorChange = (option: IExlySearchableDropdownOption) => {
        const selectedBatchSpotsFilled =
            classes.find(classItem => classItem.uuid === option.value)
                ?.slotsFilled || 0;
        if (allUserIds.length + selectedBatchSpotsFilled > maxSpots) {
            notify(
                `The selected batch has reached its maximum capacity of ${maxSpots} ${pluralise(
                    "spot",
                    maxSpots
                )}. Please choose another batch or remove some users to continue with this selection.`,
                {
                    type: toast_type_keys.error,
                }
            );
            return;
        }
        setValue(multipleSessionsFieldName, option);
    };

    return {
        multipleSessionsFieldName,
        classesOptions,
        batchesSelectorChange,
    };
};

export default useMultipleSessions;
